export default {
    namespaced: true,
    state: {
        currMenuObj: {},
        countentsFromDB: {
            node: [],
            leaf: []
        },
        currEditObj: {},
        createMode: -1,
        versionData: {},
        levelList: [
            {
                text: '第一層',
                value: 1
            },
            {
                text: '第二層',
                value: 2
            },
            {
                text: '第三層',
                value: 3
            },
            {
                text: '第四層',
                value: 4
            }
        ],
        allChapterList: [],
        dialogChapter: {
            show: false,
            name: '',
            maxWidth: '500px',
            dialogTitle: '',
            mode: 1,
            clickedActiveMenu: {}
        },
        showRemoveData: false
    },
    getters: {
        getActiveMenuListByLv(state) {
            const arr = {};
            let list = JSON.parse(JSON.stringify(state.allChapterList));
            list = list.filter((item) => {
                return (item.flag === 1 &&
                    (item.menuId !== 1 ||
                        state.dialogChapter.clickedActiveMenu.level === 1));
            });
            for (const i in list) {
                const curr = list[i];
                const key = curr.level + '_' + curr.parentId;
                if (!arr[key]) {
                    arr[key] = [];
                }
                arr[key].push(curr);
            }
            return arr;
        }
    },
    mutations: {
        SET_SHOWREMOVEDATA(state) {
            state.showRemoveData = !state.showRemoveData;
        },
        SET_SELECTMENU(state, options) {
            state.currMenuObj = {};
            state.currMenuObj = options;
        },
        SET_CURRENTCONTENT(state, options) {
            state.countentsFromDB = options;
        },
        SET_CREATEMODE(state, options) {
            state.currEditObj = {};
            state.currEditObj = JSON.parse(JSON.stringify(options.obj));
            state.createMode = options.mode;
        },
        SET_VERSIONDATA(state, options) {
            state.versionData = {};
            const newData = {};
            const menuList = state.allChapterList;
            for (const i in options) {
                const { menuId, online } = options[i];
                const curr = menuList.find(item => item.menuId === menuId);
                if (curr) {
                    const { topic, topicEn, parentId, level } = curr;
                    const newObj = { topic, topicEn, parentId, level, ...options[i] };
                    !newData[online] && (newData[online] = []);
                    newData[online].push(newObj);
                }
            }
            state.versionData = newData;
        },
        SET_DIALOGCHAPTER(state, options) {
            state.dialogChapter.clickedActiveMenu = { topic: '', topicEn: '', sn: 0, parentId: 0, level: 1 };
            state.dialogChapter.show = false;
            state.dialogChapter.name = '';
            if (options) {
                switch (options.key) {
                    case 'addItem':
                        state.dialogChapter.dialogTitle = '新增節點';
                        state.dialogChapter.mode = 1;
                        state.dialogChapter.clickedActiveMenu.topic = '';
                        state.dialogChapter.clickedActiveMenu.level = 1;
                        state.dialogChapter.clickedActiveMenu.sn = 1;
                        state.dialogChapter.clickedActiveMenu.parentId = 0;
                        break;
                    case 'editItem':
                        state.dialogChapter.dialogTitle = '編輯節點';
                        state.dialogChapter.mode = 2;
                        state.dialogChapter.clickedActiveMenu = JSON.parse(JSON.stringify(options.data));
                        break;
                    case 'editItemSwap':
                        state.dialogChapter.dialogTitle = '調整節點順序';
                        state.dialogChapter.mode = 3;
                        state.dialogChapter.clickedActiveMenu = JSON.parse(JSON.stringify(options.data));
                        break;
                    default:
                        return;
                }
                state.dialogChapter.show = true;
                state.dialogChapter.name = options.key;
            }
        },
        SET_ALLCHAPTERLIST(state, options) {
            state.allChapterList = options;
        }
    },
    actions: {
        setCurrentContent(context, options) {
            context.commit('SET_CURRENTCONTENT', {
                node: [],
                leaf: []
            });
            context.commit('SET_VERSIONDATA', {});
            if (!options.leaf) {
                context.commit('SET_VERSIONDATA', options);
            }
            else {
                for (const i in options.leaf) {
                    if (options.leaf[i].format === 'Panel') {
                        options.leaf[i].content = options.leaf[i].content === '' ? options.leaf[i].content : JSON.parse(options.leaf[i].content);
                    }
                }
                context.commit('SET_CURRENTCONTENT', options);
            }
        },
        setSelectMenu(context, options) {
            context.commit('SET_SELECTMENU', options);
        },
        setCreateMode(context, options) {
            context.commit('SET_CREATEMODE', options);
        },
        setDialogChapter(context, options) {
            context.commit('SET_DIALOGCHAPTER', options);
        },
        setAllChapter(context, options) {
            context.commit('SET_ALLCHAPTERLIST', options);
        },
        setShowRemoveData(context) {
            context.commit('SET_SHOWREMOVEDATA');
        }
    }
};
